import { Zap, Clock, MessageSquare, TrendingUp, Search, Wrench } from "lucide-react";

const features = [
  {
    icon: Clock,
    title: "Rapid Delivery",
    description: "Your site goes live in 3-7 business days, not months. We move fast because your time is money.",
  },
  {
    icon: Zap,
    title: "Lightning-Fast Speed",
    description: "Sub-second load times that keep visitors engaged and boost your search rankings.",
  },
  {
    icon: MessageSquare,
    title: "Direct Access",
    description: "Work directly with the developer—no account managers, no miscommunication, just results.",
  },
  {
    icon: TrendingUp,
    title: "Better Business Results",
    description: "Faster sites convert better. Period. Every millisecond counts for your bottom line.",
  },
  {
    icon: Search,
    title: "SEO Advantage",
    description: "Google rewards fast sites with higher rankings. Get found by more customers.",
  },
  {
    icon: Wrench,
    title: "One-Stop Solution",
    description: "Design, development, hosting, and maintenance—all handled by one team you can trust.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="features-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 id="features-title" className="text-3xl md:text-4xl font-bold mb-4">
            Why Choose Our Agency?
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            The trusted choice for ambitious businesses that need high-performance websites
            that actually deliver.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-secondary/50 border border-border ring-1 ring-white/[0.08] dark:ring-white/[0.12] rounded-lg p-6 hover:bg-secondary/70 transition-colors animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <feature.icon className="w-10 h-10 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
